import * as React from "react";
import { createRoot } from "react-dom/client";
import { InteractionType, IPublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import EquipHome from "@/components/EquipHome";
import AccountInterceptor from "@/providers/AccountInterceptor";
import { updateRibbonUI } from "@/taskpane/taskpane";
import { equipmsalinstance } from "@/services/auth/EquipMsalClient";
import { equipOptionsInstance } from "@/models/EquipOptions";
import { GetUserInfo, GetUserRoles } from "@/services/api/user-endpoints";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

export function RebuildMsalProviders() {
  root?.render(
    <MsalProvider instance={equipmsalinstance.MsalClient}>
      <AccountInterceptor />
      <MsalAuthenticationTemplate interactionType={InteractionType.Popup}>
        <EquipHome />
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
}

Office.onReady(async () => {
  try {
    await equipmsalinstance.RegenerateClient();
    RebuildMsalProviders();

    updateRibbonUI();
  } catch (err) {
    console.warn("equip initialisation failed");
    console.error(err);
  }
});

if ((module as any).hot) {
  (module as any).hot.accept("@/components/EquipHome", () => {
    const NextApp = require("@/components/EquipHome").default;
    root?.render(NextApp);
  });
}
